import { createFileRoute } from '@tanstack/react-router'
import { SettingsChooserPage } from '@/pages/settings/settings-chooser-page'

export const Route = createFileRoute('/settings/')({
  component: SettingsChooserPage,
})
